module.exports = __webpack_public_path__ + "img/hat_design_21.5e9e8b43.svg";